import React from "react";
import { Star, Quote } from "lucide-react";
import { testimonials } from "../mock";

const Testimonials = () => {
  return (
    <section className="bg-brand-sand py-20" id="reviews">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-12">
          <p className="text-brand-orange font-semibold tracking-[0.18em] text-sm uppercase mb-3">
            Testimonials
          </p>
          <h2 className="font-display font-extrabold text-brand-navy text-3xl md:text-4xl">
            What Our Happy Clients Say
          </h2>
          <div className="w-20 h-1 bg-brand-orange rounded-full mx-auto mt-4" />
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-7 border border-black/5 shadow-sm hover:shadow-lg transition-shadow relative"
            >
              <Quote className="w-10 h-10 text-brand-orange/15 absolute top-5 right-5" />
              <div className="flex gap-1 mb-4">
                {[...Array(t.rating)].map((_, k) => (
                  <Star
                    key={k}
                    className="w-5 h-5 fill-brand-orange text-brand-orange"
                  />
                ))}
              </div>
              <p className="text-slate-700 leading-relaxed mb-6">"{t.quote}"</p>
              <div className="flex items-center gap-3 pt-4 border-t border-black/5">
                <div className="w-11 h-11 rounded-full bg-brand-navy text-white font-display font-bold flex items-center justify-center">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="font-semibold text-brand-navy">{t.name}</p>
                  <p className="text-sm text-slate-500">{t.location}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
